import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, History, Heart, Users, Target, X, ZoomIn } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ClubPage = () => {
  const [lightboxImage, setLightboxImage] = useState(null);

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  const historyEvents = [
    {
      year: '1984',
      title: 'Inauguration des courts',
      color: 'from-green-500 to-emerald-600',
      images: [
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/zxtzrm1s_1984.png', alt: 'Inauguration 1984' }
      ]
    },
    {
      year: '1988',
      title: 'Buvette & Tournoi des Pâquerettes',
      color: 'from-blue-500 to-cyan-600',
      images: [
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/t7y96oi6_1988_1.png', alt: 'Construction buvette 1988' },
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/7cr88lfu_1988_2.png', alt: 'Buvette terminée 1988' },
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/vgli7se7_1988%20tournoi%20des%20paquerettes.png', alt: 'Tournoi des Pâquerettes 1988' }
      ]
    },
    {
      year: '1989',
      title: 'Tournoi des cerises',
      color: 'from-purple-500 to-pink-600',
      images: [
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/9zpwtaex_1989%20tournoi%20des%20cerises.png', alt: 'Tournoi des cerises 1989' }
      ]
    },
    {
      year: '1996',
      title: 'Club house',
      color: 'from-orange-500 to-red-600',
      images: [
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/thil2v50_1996.png', alt: 'Article club-house 1996' },
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/znv4zlpi_1996_2.png', alt: 'Club-house terminé 1996' }
      ]
    },
    {
      year: '1998',
      title: 'Promotion équipe féminine',
      color: 'from-teal-500 to-cyan-600',
      images: [
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/60xb116s_1998.png', alt: 'Équipe féminine promue 1998' }
      ]
    },
    {
      year: '2019',
      title: 'Rénovation club house',
      color: 'from-indigo-500 to-blue-600',
      images: [
        { src: 'https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/6x9mzm8b_2019.png', alt: 'Club-house rénové 2019' }
      ]
    },
    {
      year: '2024',
      title: 'Création terrain de Padel',
      color: 'from-green-500 to-emerald-600',
      images: [
        { src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/gbszujrx_padel2024.png', alt: 'Terrain de Padel 2024' },
        { src: 'https://customer-assets.emergentagent.com/job_clubtennis-update/artifacts/jaaq2pvq_Padel%20inauguration.png', alt: 'Inauguration terrain de Padel 2024' }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      {/* Lightbox Modal */}
      {lightboxImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
          >
            <X className="w-10 h-10" />
          </button>
          <img
            src={lightboxImage.src}
            alt={lightboxImage.alt}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-8">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Notre Club
            </h1>
            <p className="text-xl text-gray-600">
              Plus de 40 ans d'histoire et de passion pour le tennis
            </p>
          </div>

          {/* Hero Image */}
          <div className="mb-12 rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_tennis-cheyres/artifacts/gajw741p_TC%20Cheyres.jpeg"
              alt="TC Cheyres-Châbles - Club House"
              className="w-full h-80 object-cover"
            />
          </div>

          {/* Historique du club - Grille 2 colonnes */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-3xl mb-8">
            <div className="flex items-center mb-6">
              <History className="w-10 h-10 text-green-600 mr-3" />
              <h2 className="text-3xl font-bold text-gray-900">Histoire du Club</h2>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              {historyEvents.map((event) => (
                <div key={event.year} className="bg-white p-4 rounded-xl shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex items-start gap-3 mb-2">
                    <div className={`flex-shrink-0 w-14 h-14 bg-gradient-to-br ${event.color} rounded-full flex items-center justify-center`}>
                      <span className="text-white font-bold text-xs">{event.year}</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-base font-bold text-gray-900">{event.title}</h3>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 ml-17">
                    {event.images.map((image, idx) => (
                      <div 
                        key={idx}
                        onClick={() => openLightbox(image.src, image.alt)}
                        className="relative group cursor-pointer"
                      >
                        <img 
                          src={image.src}
                          alt={image.alt}
                          className="w-20 h-20 object-cover rounded-lg transition-transform group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
                          <ZoomIn className="w-4 h-4 text-white" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Valeurs, Communauté, Installations */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-2xl">
              <Heart className="w-10 h-10 text-blue-600 mb-3" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">Nos Valeurs</h3>
              <p className="text-gray-700 leading-relaxed text-sm">
                Passion, convivialité et fair-play sont au cœur de notre club. 
                Nous accueillons tous les joueurs dans une atmosphère chaleureuse.
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-6 rounded-2xl">
              <Users className="w-10 h-10 text-orange-600 mb-3" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">Notre Communauté</h3>
              <p className="text-gray-700 leading-relaxed text-sm">
                Le club rassemble des membres de tous âges et de tous niveaux. 
                Chacun trouve sa place dans notre grande famille.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl">
              <Target className="w-10 h-10 text-purple-600 mb-3" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">Nos Installations</h3>
              <p className="text-gray-700 leading-relaxed text-sm">
                Courts synthétiques, padel moderne, mini-court gratuit et club-house rénové.
              </p>
            </div>
          </div>

          <div className="bg-gray-900 text-white p-10 rounded-3xl">
            <h2 className="text-3xl font-bold mb-4">Rejoignez-nous !</h2>
            <p className="text-gray-300 mb-6 text-lg">
              Devenez membre du TC Cheyres-Châbles et profitez de toutes nos installations 
              et activités. Inscrivez-vous dès maintenant !
            </p>
            <a 
              href="http://tccheyres.plugin.ch/user/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105"
            >
              Devenir membre
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ClubPage;